import type { storeAddressT } from '@store/UserStore.type';
import { Picture } from '@ui';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import type { CSSProperties, FC, MouseEvent, RefObject } from 'react';
import {
  listItemActive,
  listItemInactive,
  editAddressBlack,
  trashAddressBlack
} from '@images';
import { createAddressString } from '@utils/address';
import { useStores } from '@root/src/stores';

interface ChooseAddressPickupsMobileListProps {
  style?: CSSProperties;
  selectedAddress: number | null;
  elRefs?: Array<RefObject<HTMLDivElement>>;
  selectAddress: (item: storeAddressT) => void;
  changeStateModalEdit: (
    item: storeAddressT,
    e: React.MouseEvent<HTMLElement>
  ) => void;
  deleteAddress: (e: MouseEvent<HTMLElement>, item: storeAddressT) => void;
}

const ChooseAddressPickupsMobileList: FC<ChooseAddressPickupsMobileListProps> =
  observer(
    ({
      style,
      selectedAddress,
      elRefs,
      deleteAddress,
      changeStateModalEdit,
      selectAddress
    }) => {
      const { userStore } = useStores();
      const { moscowAddresses } = userStore;
      if (!moscowAddresses.length) {
        return null;
      }
      return (
        <div className='list custom-scroll' style={style}>
          {moscowAddresses.map((item, index) => {
            const isActive = item.id === Number(selectedAddress);
            return (
              <div
                key={item.id}
                ref={elRefs?.[index]}
                data-key={item.id}
                className={clsx(`address-item`, isActive && ' selected')}
                onClick={() => {
                  selectAddress(item);
                }}
              >
                <span className='block-address'>
                  <Picture
                    className='icon'
                    icon={isActive ? listItemActive : listItemInactive}
                    height='20'
                    alt=''
                  />
                  <div className='full-addres'>
                    {createAddressString(item, true, false, true)}
                  </div>
                </span>
                <span className='block-address'>
                  <Picture
                    className='icon-edit'
                    icon={editAddressBlack}
                    height='20'
                    alt=''
                    onClick={e => {
                      changeStateModalEdit(item, e);
                    }}
                  />
                  <Picture
                    className='icon-remove'
                    icon={trashAddressBlack}
                    height='20'
                    alt=''
                    onClick={e => {
                      deleteAddress(e, item);
                    }}
                  />
                </span>
              </div>
            );
          })}
        </div>
      );
    }
  );

export default ChooseAddressPickupsMobileList;
